<template>
    <a-layout-footer class="footer">
        <div class="footer-content">
            <div class="footer-sections">
                <div class="footer-section">
                    <h3>{{ $t('footer.contact.title') }}</h3>
                    <p><icon-phone /> {{ $t('footer.contact.phone') }}</p>
                    <p><icon-mail /> hao.xiaofeng@yongtao-hk.com</p>
                    <p><icon-environment /> {{ $t('footer.contact.address') }}</p>
                </div>
                <div class="footer-section">
                    <h3>{{ $t('footer.quickLinks.title') }}</h3>
                    <ul>
                        <li><router-link to="/resources">{{ $t('footer.quickLinks.resources') }}</router-link></li>
                        <li><router-link to="/about">{{ $t('footer.quickLinks.about') }}</router-link></li>
                        <li><router-link to="/contact">{{ $t('footer.quickLinks.contact') }}</router-link></li>
                    </ul>
                </div>
                <div class="footer-section">
                    <h3>{{ $t('footer.social.title') }}</h3>
                    <div class="social-links">
                        <a-button type="link"><icon-wechat /></a-button>
                        <a-button type="link"><icon-weibo /></a-button>
                        <a-button type="link"><icon-qq /></a-button>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <p>{{ currentYear }} {{ $t('footer.copyright') }}</p>
            </div>
        </div>
    </a-layout-footer>
</template>

<script>
import {
    PhoneFilled,
    MailFilled,
    EnvironmentFilled,
    WechatFilled,
    WeiboCircleFilled,
    QqCircleFilled
} from '@ant-design/icons-vue'

export default {
    name: 'LayoutFooter',
    components: {
        IconPhone: PhoneFilled,
        IconMail: MailFilled,
        IconEnvironment: EnvironmentFilled,
        IconWechat: WechatFilled,
        IconWeibo: WeiboCircleFilled,
        IconQq: QqCircleFilled
    },
    setup() {
        const currentYear = new Date().getFullYear()
        return {
            currentYear
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    background: #001529;
    padding: $spacing-lg 0;
    color: rgba(255, 255, 255, 0.65);

    &-content {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 $spacing-md;

        @media (max-width: 768px) {
            padding: 0 $spacing-sm;
        }
    }

    &-sections {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: $spacing-lg;
        margin-bottom: $spacing-lg;

        @media (max-width: 768px) {
            grid-template-columns: 1fr;
            gap: $spacing-md;
            text-align: center;
        }
    }

    &-section {
        h3 {
            color: #fff;
            margin-bottom: $spacing-md;
            font-size: 18px;

            @media (max-width: 768px) {
                font-size: 16px;
                margin-bottom: $spacing-sm;
            }
        }

        p {
            margin-bottom: $spacing-sm;
            display: flex;
            align-items: center;
            gap: $spacing-xs;

            @media (max-width: 768px) {
                justify-content: center;
                margin-bottom: $spacing-xs;
            }
        }

        ul {
            list-style: none;
            padding: 0;

            li {
                margin-bottom: $spacing-sm;

                @media (max-width: 768px) {
                    margin-bottom: $spacing-xs;
                }

                a {
                    color: rgba(255, 255, 255, 0.65);
                    text-decoration: none;

                    &:hover {
                        color: #fff;
                    }
                }
            }
        }
    }

    .social-links {
        display: flex;
        gap: $spacing-sm;

        @media (max-width: 768px) {
            justify-content: center;
        }

        .ant-btn {
            color: rgba(255, 255, 255, 0.65);
            font-size: 24px;

            &:hover {
                color: #fff;
            }
        }
    }

    &-bottom {
        text-align: center;
        margin-top: $spacing-lg;
        padding-top: $spacing-lg;
        border-top: 1px solid rgba(255, 255, 255, 0.1);

        @media (max-width: 768px) {
            margin-top: $spacing-md;
            padding-top: $spacing-md;
        }

        p {
            margin-bottom: $spacing-xs;

            @media (max-width: 768px) {
                font-size: 12px;
            }
        }
    }
}
</style>
